
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  TagResource,
  TagSuggestionResource,
} from '../models';
import {
    TagResourceFromJSON,
    TagResourceToJSON,
    TagSuggestionResourceFromJSON,
    TagSuggestionResourceToJSON,
} from '../models';

export interface AutocompleteRequest {
    query: string;
}

export interface FindSuggestionsRequest {
    category: string;
}

/**
 * 
 */
export class PublicSkillSuggestionApi extends runtime.BaseAPI {

    /**
     * Gives autocomplete results for skill search
          */
    async autocompleteRaw(requestParameters: AutocompleteRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<TagSuggestionResource>>> {
        if (requestParameters['query'] == null) {
            throw new runtime.RequiredError(
                'query',
                'Required parameter "query" was null or undefined when calling autocomplete().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<TagSuggestionResource>>({
            path: `/profile/public-api/suggest/tags/autocomplete`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(TagSuggestionResourceFromJSON);
        return response;
    }

    /**
     * Gives autocomplete results for skill search
          */
    async autocomplete(requestParameters: AutocompleteRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<TagSuggestionResource>> {
        const response = await this.autocompleteRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Suggest skills according to the chosen category
          */
    async findSuggestionsRaw(requestParameters: FindSuggestionsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<TagResource>>> {
        if (requestParameters['category'] == null) {
            throw new runtime.RequiredError(
                'category',
                'Required parameter "category" was null or undefined when calling findSuggestions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['category'] != null) {
            queryParameters['category'] = requestParameters['category'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<TagResource>>({
            path: `/profile/public-api/suggest/tags`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(TagResourceFromJSON);
        return response;
    }

    /**
     * Suggest skills according to the chosen category
          */
    async findSuggestions(requestParameters: FindSuggestionsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<TagResource>> {
        const response = await this.findSuggestionsRaw(requestParameters, initOverrides);
        return response._data;
    }

}
